import { ReactNode } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

type RequireAuthProps = {
  children: ReactNode;
};

const RequireAuth = ({ children }: RequireAuthProps) => {
  const { user, userManagementEnabled, userManagementResolved } = useAuth();
  const location = useLocation();

  if (!userManagementResolved) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "50vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!userManagementEnabled) {
    return <>{children}</>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (user.forcePasswordReset && location.pathname !== "/password-reset") {
    return <Navigate to="/password-reset" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
